import useStore from "../Store/useStore";
import { signOut } from "next-auth/react";
import useCheckoutStatus from "../Store/useCheckoutStatus";

export const useResetAllStores = () => {
    const { resetPaymentStatus } = useCheckoutStatus()
    const { userData, resetBoxItems, resetUser, resetBox, resetPayment, resetSurvey, setCheckoutDetails } =
        useStore();

    const resetAllStores = ({ logout = false } = {}) => {
        localStorage?.removeItem("surveyAnswers");
        localStorage?.removeItem("surveyQuestions");
        localStorage?.removeItem("StyleMyWardrobeAnswers");
        localStorage?.removeItem("apple-name-modal");
        localStorage?.removeItem("dashboard-previous-screen")

        document?.cookie?.split(";")?.forEach(cookie => {
            const name = cookie?.split("=")?.[0]?.trim();
            document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/`;
        });

        if (logout) {
            signOut({ redirect: false }).then(() => {
                if (userData) {
                    resetBoxItems?.();
                    resetUser?.();
                    resetBox?.();
                    resetPayment?.();
                    resetSurvey?.();
                    setCheckoutDetails?.(null)
                    resetPaymentStatus?.()
                }
                window.location.href = "/login";
            });
        }
    };

    return resetAllStores;
};
